import React from 'react';

function ColorCircle({
                       color, size = 10, children = <div></div>,
                       clssName = '',
                       style = {}
                     }) {
  return (
    <div
      className={clssName}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        display: 'flex',
        whiteSpace: 'nowrap',
        color: 'white',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: `${size - 3}px`, // 根据圆的大小调整字体大小
        ...style
        // marginRight: 5
      }}>
      {children}
    </div>
  );
}

export default ColorCircle;
